<template>
    <div>
        <Head title="Create Story" />
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" href="/story">Story</Link>
            <span class="text-indigo-400 font-medium">/</span> Create
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store" enctype="multipart/form-data">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2" label="Story Title" />

                    <div>
                        <label class="form-label">Story Cover:</label>
                        <div class="pb-8 pr-6 w-full lg:w-full" >
                            <input ref="fileInput" type="file" name="file" />
                        </div>
                    </div>
                    <div>
                        <label class="form-label">Choose Tags:</label>
                        <div class="pb-8 pr-6 w-full" >
                            <vue3-tags-input :tags="form.tags"
                                             @on-tags-changed="handleChangeTag"
                                             :addTagOnKeys="addTagOnKeys"
                                             placeholder="insert tags" />
                        </div>
                    </div>

                    <div class="my-quill-editor w-full" style="padding-bottom: 3.5rem !important">
                        <QuillEditor contentType="html" v-model:content="form.content" theme="snow" />
                    </div>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Story</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from "@/Shared/TextareaInput.vue";
import Vue3TagsInput from 'vue3-tags-input';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
    components: {
        FileInput,
        Head,
        QuillEditor,
        Link,
        TextareaInput,
        LoadingButton,
        SelectInput,
        TextInput,
        Vue3TagsInput,
        vSelect
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            girlProfile:'',
            form: this.$inertia.form({
                title: '',
                content: '',
                cover: '',
                tags: ['hot'],
            }),
            addTagOnKeys: [13, 188]
        }
    },
    methods: {
        async store() {

            const fileInput = this.$refs.fileInput;
            const formData = new FormData();
            formData.append('cover', fileInput.files[0]);
            formData.append('title', this.form.title);
            formData.append('content', this.form.content);
            formData.append('tags', this.form.tags);

            await this.$inertia.post('/story', formData, {
                preserveScroll: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
        },
        handleChangeTag(tags) {
            this.form.tags = tags;
        },
    },
}
</script>

<style>
.my-quill-editor .ql-toolbar {
    min-width: 0;
    width: 100% !important;
}
</style>
